<script setup lang="ts">
import type {RcsSuggestion, RcsText} from "@/notification-template/interfaces";
import RCSSuggestion from "@/notification-template/components/rcs/RCSSuggestion.vue";

defineProps<{
    payload: RcsText
}>();

defineEmits<{
    (e: 'suggestionClick', suggestion: RcsSuggestion): void
}>();
</script>

<template>
  <div class="rounded-lg px-3 py-2 bg-white">
    <p class="text-sm leading-relaxed whitespace-pre-wrap">
      {{ payload.content }}
    </p>
    <div v-if="payload.suggestions?.length" class="mt-2 flex flex-wrap gap-1">
      <RCSSuggestion
        v-for="(suggestion, index) in payload.suggestions"
        :key="index"
        :payload="suggestion"
        @click="$emit('suggestionClick', suggestion)"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
